export default{
    fnPrintDate: function(_date){

        let _month=_date.getMonth();
        _month="0"+(_month+1);
        let _day="0"+_date.getDate();

        return _date.getFullYear()+"-"+_month.substring(_month.length-2,_month.length)+"-"+_day.substring(_day.length-2,_day.length);

    }

    ,fnPrintDateByNum: function(_date){
        if(_date!=null && _date!=""){
            let year=_date.substring(0,4);
            let month=_date.substring(4,6);
            let day=_date.substring(6,8);
            return year+"-"+month+"-"+day;
        }
        return "";
    }

    ,fnConvertStrDate: function(str,exp){
        let year;
        let month;
        let day;
        if(exp == null){
            year = str.substring(0,4);
            month = str.substring(4,6);
            day = str.substring(6,8);
        }else{
            str=str.split(exp);
            year = str[0];
            month = str[1];
            day = str[2];
        }
        return new Date(year,month,day);
    }

    ,fnConvertDateStr: function(paramDate,exp){
        let _date = new Date(paramDate);
        let month = _date.getMonth() + 1;
        let day = _date.getDate();
        let year = _date.getFullYear();
        let _month = month < 10 ? "0"+ month: month;
        let _day = day < 10 ? "0"+ day: day;
        if(exp == null){
            return year+ "/"+ _month+ "/" + _day;
        }else{
            return year+ exp+ _month+ exp + _day;
        }
    }

    ,fnOnFileDownload:function(seq){
		window.location='/file/download/'+seq;
    }
    ,fnConvertDateDayeStr : function(_date,exp){
        if(_date==null){
            return '';
        }

        if(typeof _date == 'string'){
            let _yy = _date.substring(0,4);
            let _mm = _date.substring(4,6);
            let _dd = _date.substring(6,8);
            let date = _yy + exp + _mm + exp +_dd;
            return date;
        }
    }
    ,fnConvertDateTimeStr : function(_date,exp){
        if(_date==null){
            return '';
        }

        let dt = new Date(_date);

        if(typeof _date == 'string'){
            let _splitDate = _date.split(' ');
            let _yymmdd = _splitDate[0].split('-');
            let _hhmmss = _splitDate[1].split(':');
            dt = new Date(_yymmdd[0], _yymmdd[1]-1, _yymmdd[2], _hhmmss[0], _hhmmss[1], _hhmmss[2]);
        }

        let month = dt.getMonth() + 1;
        let day = dt.getDate();
        let year = dt.getFullYear();
        let hh=dt.getHours();
        let min=dt.getMinutes();
        let ss=dt.getSeconds();
        day=day<10?"0"+day:day;
        hh=hh<10?"0"+hh:hh;
        min=min<10?"0"+min:min;
        ss=ss<10?"0"+ss:ss;
        let _month = month < 10 ? "0"+ month: month;
        if(exp == null){
            return year+ "/"+ _month+ "/" + day+" "+hh+":"+min+":"+ss;
        }else{
            return year+ exp+ _month+ exp + day+" "+hh+":"+min+":"+ss;
        }
    }

    ,toDay_YYYYMMDD: function (n) {
        let now = new Date();
        if (n != undefined && n != null) {
          now.setDate(now.getDate()+parseInt(n))
        }
        let y = now.getFullYear();
        let m = now.getMonth() + 1;
        let d = now.getDate();
        return '' + y +'-'+ (m < 10 ? '0' : '') + m +'-'+ (d < 10 ? '0' : '') + d;
    }

    ,toDay_MMDD: function (paramDate) {
        let _date = new Date(paramDate);
        let month = _date.getMonth() + 1;
        let day = _date.getDate();
        let _month = month < 10 ? "0"+ month: month;
        let _day = day < 10 ? "0"+ day: day;

        return _month+ '-' + _day;
    }

    ,fnConvertStrPrintDateByNum: function(_date){
        if(_date!=null && _date!=""){
            let date = _date.replace("-","");
            let year=date.substring(0,4);
            let month=date.substring(4,6);
            let day=date.substring(6,8);
            return year+"-"+month+"-"+day;
        }
        return "";
    }

    ,fnNumberFormat: function(inputNumber) {
        return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    ,fnGrpSendYnCode:function(){
        const _list = [{code:"1",value:"수신"}, {code:"2", value:"미수신"}];
        return _list;
    }
    ,fnGrpAgreeYnCode:function(){
        const _list = [{code:"1",value:"동의"}, {code:"0", value:"미동의"}];
        return _list;
    }
    ,fnBrdOrderingCode:function(){
        const _list = [{code:"1",value:"최신순"}, {code:"2", value:"인기순"}];
        return _list;
    }
    //시설관리 셀렉트박스 코드
    ,fnFacSelectKindCode:function(){
        const _list = [{code:"all",value:"전체"}, {code:"title", value:"제목"}, {code:"content", value:"내용"}];
        return _list;
    }
    // 상태(결제상태)
    ,fnStatusCode:function(){
        const _list = [{code:"all",value:"전체"}, {code:"ready",value:"접수전"}, {code:"wait",value:"대기신청"}, {code:"approve", value:"신청완료"}, {code:"complete", value:"이수"}];
        return _list;
    }
    // 상태(결제)
    ,fnPaymentCode:function(){
        const _list = [{code:"all",value:"전체"}, {code:"Y", value:"결제완료"}, {code:"N", value:"미결제"}, {code:"NO", value:"결제없음"}];
        return _list;
    }
    ,fnGetCurrentDate:function(){
        let _date = new Date();
        let _yyyy = _date.getFullYear();
        let _mm = _date.getMonth() + 1;
        let _dd = _date.getDate();
        let _finalmm = (_mm < 10) ? "0" + _mm : _mm;
        let _finaldd= (_dd< 10) ? "0" + _dd : _dd;
        let _current = _yyyy + '-' +  _finalmm + "-" + _finaldd;
        return _current;
    }
    ,fnGetCurrentParamDate:function(date, split){
         let _date = date.split(split);
         if(_date.length > 0){
             let _yyyy = _date[0];
             let _mm = _date[1];
             let _dd = _date[2];
             return _yyyy + _mm +_dd;
         }
    }
    //특정 월요일과 일요일의 날짜 구함
    ,fnGetWeekDayNonFilter:function(_date, isMonday){

        let _vn_day = new Date(_date);
        let _day = _vn_day.getDay();
        let _mon = _vn_day.getDate() - _day + (_day == 0 ? -6 : isMonday);
        let _monDate = new Date(_vn_day.setDate(_mon)).toISOString().substring(0,10);
        let _finalDate = _monDate.replace(/-/g, '.');
        return _finalDate
    }
    ,fnGetWeekToDay:function(_date, filter){

        let _vn_day = new Date(_date);
        let _day = _vn_day.getDay();
        let _mon = _vn_day.getDate();
        let _monDate = new Date(_vn_day.setDate(_mon)).toISOString().substring(0,10);
        let _finalDate = _monDate.replace(/-/g, filter);
        return _finalDate
    }
    ,fnGetWeekDay:function(_date, isMonday, filter){

        let _vn_day = new Date(_date);

        let _day = _vn_day.getDay();
        let _mon = _vn_day.getDate() - _day - (_day == 0 ? -6 : isMonday);
        let _monDate = new Date(_vn_day.setDate(_mon)).toISOString().substring(0,10);
        let _finalDate = _monDate.replace(/-/g, filter);
        return _finalDate
    }
    , fnNumberWithComma:function(_value){
        return _value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
}
